export const PagePreloader = () => {
    return (
        <div className='animate-pulse dark:text-white w-full p-6'>
            <div role="status" className="w-full flex flex-col gap-2">
                <div className="flex items-center gap-4">
                    <span className="w-[200px] h-5 bg-slate-200 dark:bg-slate-600 animate-pulse block"></span>
                    {/* <span className="w-full h-5 bg-slate-700 animate-pulse block"></span> */}
                </div>
                <span className="w-full h-[70vh] bg-slate-200 dark:bg-slate-600 animate-pulse"></span>
            </div>
        </div>
    )
}